import { Day as E } from "@vue-unistra/limitdayjs";
const k = { actions: { home: "Home return", max: { zoomIn: "Zooming in further is not possible", zoomOut: "Zooming out further is not possible" }, nextEvent: "Next event", previousEvent: "Previous event", zoomIn: "Zoom in", zoomOut: "Zoom out" }, errors: { HTMLContainerNotDefined: "Timeline: HTML container is not defined.", events: { date: { endDateIsBeforeStartDate: 'Event "{event}" has an end date before its start date', invalidEndDate: 'Event "{event}" has an invalid end date', invalidStartDate: 'Event "{event}" has an invalid start date' } }, format: { eventsNotDefined: "Timeline: Events are not defined. See the documentation for more information.", eventsWrongFormat: "Timeline: Events are not in the right format. See the documentation for more information.", initialZoomNotDefined: "Timeline: Initial zoom is not defined. See the documentation for more information.", initialZoomWrongFormat: "Timeline: Initial zoom is not in the right format. See the documentation for more information.", isOnGoingNotDefined: "Timeline: Is on going indicator is not defined. See the documentation for more information.", isOnGoingWrongFormat: "Timeline: Is on going indicator is not in the right format. See the documentation for more information.", zoomsNotDefined: "Timeline: Zooms are not defined. See the documentation for more information.", zoomsWrongFormat: "Timeline: Zooms are not in the right format. See the documentation for more information." }, localeNotSupported: 'Timeline: Language "{locale}" is not supported, replaced by "{fallback}".', noEvent: "No events found." }, loading: "Loading", months: { apr: "Apr.", aug: "Aug.", dec: "Dec.", feb: "Feb.", jan: "Jan.", jul: "Jul.", jun: "Jun.", mar: "Mar.", may: "May", nov: "Nov.", oct: "Oct.", sep: "Sep." } }, P = {
  __timeline: k
}, Y = { actions: { home: "Retour à l'origine", max: { zoomIn: "Impossible de zoomer plus loin", zoomOut: "Impossible de dézoomer plus loin" }, nextEvent: "Événement suivant", previousEvent: "Événement précédent", zoomIn: "Zoomer", zoomOut: "Dézoomer" }, errors: { HTMLContainerNotDefined: "Timeline: Le conteneur HTML n'est pas défini.", events: { date: { endDateIsBeforeStartDate: `L'événement "{event}" a une date de fin antérieure à sa date de début`, invalidEndDate: `L'événement "{event}" a une date de fin invalide`, invalidStartDate: `L'événement "{event}" a une date de début invalide` } }, format: { eventsNotDefined: "Timeline: Les événements ne sont pas définis. Cf. la documentation pour plus d'informations.", eventsWrongFormat: "Timeline: Les événements n'ont pas le bon format. Cf. la documentation pour plus d'informations.", initialZoomNotDefined: "Timeline: Le zoom initial n'est pas défini. Cf. la documentation pour plus d'informations.", initialZoomWrongFormat: "Timeline: Le zoom initial n'a pas le bon format. Cf. la documentation pour plus d'informations.", isOnGoingNotDefined: "Timeline: L'indicateur d'événement en cours n'est pas défini. Cf. la documentation pour plus d'informations.", isOnGoingWrongFormat: "Timeline: L'indicateur d'événement en cours n'a pas le bon format. Cf. la documentation pour plus d'informations.", zoomsNotDefined: "Timeline: Les zooms ne sont pas définis. Cf. la documentation pour plus d'informations.", zoomsWrongFormat: "Timeline: Les zooms n'ont pas le bon format. Cf. la documentation pour plus d'informations." }, localeNotSupported: `Timeline: La langue "{locale}" n'est pas supportée, remplacée par "{fallback}".`, noEvent: "Aucun événement trouvé" }, loading: "Modifications en cours", months: { apr: "Avr.", aug: "Août", dec: "Déc.", feb: "Fév.", jan: "Jan.", jul: "Juil.", jun: "Juin", mar: "Mar.", may: "Mai", nov: "Nov.", oct: "Oct.", sep: "Sept." } }, Z = {
  __timeline: Y
};
class g {
  static #e;
  _messages;
  #t = ["en", "fr"];
  #n;
  constructor(e) {
    this.#n = e, this._messages = { en: P, fr: Z };
  }
  get locale() {
    return this.#n;
  }
  set locale(e) {
    if (!this.#t.includes(e))
      throw this.#n = "fr", this._t("__timeline.errors.localeNotSupported", { locale: e, fallback: "fr" });
    this.#n = e;
  }
  static getInstance(e) {
    return g.#e || (g.#e = new g(e)), g.#e;
  }
  static reset() {
    g.#e = void 0;
  }
  _t(e, t = {}) {
    const i = (s) => {
      if (typeof s == "string") {
        const a = s.match(/{(?<options>\S*)}/g);
        if (a)
          for (const r of a)
            s = s.replace(new RegExp(r, "g"), t[r.split(/[{|}]/)[1]]);
      }
      return s;
    }, n = (s) => e.split(".").reduce((a, r) => {
      let c = a[r];
      if (c === void 0) throw Error();
      return c = i(c), c;
    }, s);
    try {
      return n(this._messages[this.#n]);
    } catch {
      try {
        return n(Z);
      } catch {
        return e;
      }
    }
  }
}
class H {
  observers = [];
  subscribe(e) {
    this.observers.push(e);
  }
  /*unsubscribe(observer: Function): void {
    this.observers = this.observers.filter((obs) => obs !== observer)
  }*/
  reset() {
    this.observers = [];
  }
  notify(e) {
    this.observers.forEach((t) => t(e));
  }
}
class y extends H {
  static #e;
  static getInstance() {
    return y.#e || (y.#e = new y()), y.#e;
  }
}
function b(f = null) {
  return { value: f };
}
class x extends H {
  static #e;
  static getInstance() {
    return x.#e || (x.#e = new x()), x.#e;
  }
}
class C extends H {
  static #e;
  static getInstance() {
    return C.#e || (C.#e = new C()), C.#e;
  }
}
const N = () => [
  "millennium",
  "halfMillennium",
  "bicentenary",
  "century",
  "biDecade",
  "decade",
  "lustrum",
  "biennial",
  "year"
], A = (f) => ({
  diffDivision: 0,
  divisionNb: 0,
  divisionType: "year",
  divisionWidth: 0,
  limits: {
    end: "",
    start: ""
  },
  months: [],
  screenDivisionNb: 0,
  timelineLimits: {
    end: "",
    start: ""
  },
  timelineWidth: 0,
  zoom: f
}), I = () => N().reduce(
  (f, e) => (f[e] = A(e), f),
  {}
), h = {
  actualZoom: b(A("year")),
  dark: !1,
  elementContainer: b(null),
  timeline: b(document.createElement("div")),
  timelineContainer: b(document.createElement("div")),
  timelineIsOnGoing: b(!1),
  timelineLoadingContainer: b(document.createElement("div")),
  zoom: b("year"),
  zoomsData: I(),
  zooms: N()
}, v = () => {
  const f = y.getInstance(), e = x.getInstance(), t = C.getInstance();
  return {
    ...h,
    setElementContainer: (o) => {
      h.elementContainer.value = o;
    },
    i18nObservable: t,
    initDarkMode: (o) => {
      h.dark = o;
    },
    setDarkMode: (o) => {
      h.dark = o;
    },
    initZoom: (o) => {
      h.zoom.value = o, h.actualZoom.value = { ...h.zoomsData[o] }, h.timelineContainer.value.style.setProperty("--tl-width", `${h.zoomsData[o].timelineWidth}px`);
    },
    initZoomsData: (o) => {
      const m = h.elementContainer.value?.clientWidth || 0;
      for (const l in o) {
        const { events: L, ...p } = o[l], D = Math.ceil(m / p.screenDivisionNb);
        let w = p.limits.end;
        if (h.timelineIsOnGoing.value) {
          const z = new E(), W = Math.round(new E(w).diff(z, p.divisionType) / p.diffDivision);
          W < 0 && (w = z.toISOString(), p.divisionNb += 1 + Math.abs(W));
        }
        h.zoomsData[l] = {
          ...p,
          timelineLimits: {
            ...p.timelineLimits,
            end: w
          },
          divisionWidth: D,
          timelineWidth: D * (p.divisionNb + p.screenDivisionNb - 1)
        };
      }
    },
    setZoom: (o) => {
      h.zoom.value = o, h.actualZoom.value = { ...h.zoomsData[o] }, h.timelineContainer.value.style.setProperty("--tl-width", `${h.zoomsData[o].timelineWidth}px`), f.notify(h.zoom.value);
    },
    zoomObservable: f,
    resetTimeline: () => {
      h.dark = !1, h.timeline.value = document.createElement("div"), h.timelineContainer.value = document.createElement("div"), h.zoom.value = "year", h.zoomsData = I();
    },
    resetObservable: e
  };
};
class T {
  _htmlElement;
  _i18n;
  constructor(e, t) {
    const { elementContainer: i } = v();
    this._i18n = g.getInstance(
      t ?? navigator.language.split("-")[0] ?? "fr"
    ), this._htmlElement = e ?? i.value;
  }
  _t(e, t = {}) {
    return this._i18n._t(e, t);
  }
  _e(e, t) {
    this._htmlElement.dispatchEvent(
      new CustomEvent(e, {
        detail: t,
        bubbles: !0,
        cancelable: !0
      })
    );
  }
}
const O = {
  events: []
}, S = () => ({
  addEventListener: (t, i, n) => {
    n.addEventListener(t, i), O.events.push({ event: t, callback: i, element: n });
  },
  removeEventListeners: () => {
    O.events.forEach(({ event: t, callback: i, element: n }) => {
      n.removeEventListener(t, i);
    });
  }
});
class $ extends T {
  constructor(e, t) {
    super(), this._event = e;
    const { eventErrors: i, eventObservable: n } = _();
    try {
      this.#t = new E(e.date.start.date);
    } catch {
      i.value.push(this._t("__timeline.errors.events.date.invalidStartDate", { event: e.title }));
    }
    if (this.#f(this.#t, "start"), this.#i = e.date.start.display ?? "", e.isOnGoing)
      this.#u = !0, this.#o = new E(), this.#d = !0, this.#c = !0;
    else if (e.date.end) {
      try {
        this.#o = new E(e.date.end.date);
      } catch {
        i.value.push(this._t("__timeline.errors.events.date.invalidEndDate", { event: e.title }));
      }
      if (this.#f(this.#o, "end"), this.#l = e.date.end.display ?? "", this.#o.isBefore(this.#t))
        throw new Error(this._t("__timeline.errors.events.date.endDateIsBeforeStartDate", { event: e.title }));
    }
    this.#m = e.title, this.#e = e.id, this.#s = e.previous, this.#h = e.next, this.#v = t, n.subscribe(() => this.#_()), this.#p();
  }
  #e;
  #t;
  #n = !1;
  #r = !1;
  #i;
  #o = null;
  #d = !1;
  #c = !1;
  #l;
  #s = null;
  #h = null;
  #m;
  #u = !1;
  #v = {
    biDecade: { start: 0, end: 0 },
    bicentenary: { start: 0, end: 0 },
    biennial: { start: 0, end: 0 },
    century: { start: 0, end: 0 },
    decade: { start: 0, end: 0 },
    halfMillennium: { start: 0, end: 0 },
    lustrum: { start: 0, end: 0 },
    millennium: { start: 0, end: 0 },
    year: { start: 0, end: 0 }
  };
  #a = null;
  get eventContainer() {
    return this.#a;
  }
  // get startDate(): Day {
  //   return this.#startDate
  // }
  // get endDate(): Day | null {
  //   return this.#endDate
  // }
  get id() {
    return this.#e;
  }
  get next() {
    return this.#h;
  }
  get previous() {
    return this.#s;
  }
  get text() {
    return this.#m;
  }
  get timelineEvent() {
    return this._event;
  }
  get hasEndDate() {
    return this.#o !== null;
  }
  // static convertDateNumberToString(date: number): string {
  //   return `${date < 0 ? '-' : '+'}${Math.abs(date).toString().padStart(6, '0')}`
  // }
  displayDate(e) {
    return e === "start" ? this.#i || this.#t.format(this.#n ? "DD MMM YYYY" : this.#r ? "MMM YYYY" : "YYYY") : this.#l || this.#o?.format(this.#d ? "DD MMM YYYY" : this.#c ? "MMM YYYY" : "YYYY") || "";
  }
  updateRenderPosition() {
    const { actualZoom: e } = v(), { start: t, end: i } = this.#v[e.value.zoom], n = () => new E().diff(this.#t, e.value.divisionType) / e.value.diffDivision * e.value.divisionWidth, s = {
      left: t * e.value.divisionWidth + e.value.divisionWidth * e.value.screenDivisionNb / 2,
      width: this.#u ? n() : this.hasEndDate ? (i - t) * e.value.divisionWidth : 100,
      position: 1
    };
    this.#a.style.setProperty("--event-left", `${s.left}px`), this.#a.style.setProperty("--event-width", `${s.width}px`);
    const { eventPositions: a } = _(), r = Object.values(a.value).filter((d) => s.left >= d.left && s.left <= d.left + d.width || s.left + s.width >= d.left && s.left + s.width <= d.left + d.width).sort((d, o) => o.left - d.left);
    function c(d, o) {
      let m;
      switch (d) {
        case 1:
          return o[0] === 1 ? 2 : 1;
        case 2:
          return o.includes(1) ? o.includes(2) ? 3 : 2 : 1;
        default:
          return m = o.slice(0, 2), m.includes(1) ? m.includes(2) ? 3 : 2 : 1;
      }
    }
    r.length > 0 && (s.position = c(
      r.length,
      r.map(({ position: d }) => d)
    )), a.value[this.#e] = s, this.#a.classList.remove("timeline__events__event--position-1"), this.#a.classList.remove("timeline__events__event--position-2"), this.#a.classList.remove("timeline__events__event--position-3"), this.#a.classList.add("timeline__events__event--position-" + s.position);
  }
  #f(e, t) {
    this[`#has${t === "start" ? "Star" : "End"}DateDay`] = !!e.day, this[`#has${t === "start" ? "Star" : "End"}DateMonth`] = !!e.month;
  }
  #_() {
    const { eventSelected: e } = _();
    if (e.value === this) {
      this.#a.classList.add("timeline__events__event--selected");
      return;
    }
    this.#a.classList.remove("timeline__events__event--selected");
  }
  #p() {
    const { addEventListener: e } = S();
    this.#a = document.createElement("article");
    const t = document.createElement("h2");
    t.innerHTML = this.#m;
    const i = document.createElement("header");
    i.setAttribute("data-testId", "event-header-title"), i.appendChild(t), e(
      "click",
      () => {
        const { selectEvent: a } = _();
        a(this), this._e("event-click", this.timelineEvent);
      },
      i
    );
    const n = document.createElement("section"), s = document.createElement("footer");
    this.#a.classList.add("timeline__events__event"), this.#a.appendChild(i), this.#a.appendChild(n), this.#a.appendChild(s), this.#a.classList.add(
      this.hasEndDate ? "timeline__events__event--period" : "timeline__events__event--single"
    ), e(
      "mouseover",
      () => {
        this.#a.classList.add("timeline__events__event--hover");
      },
      i
    ), e(
      "mouseout",
      () => {
        this.#a.classList.remove("timeline__events__event--hover");
      },
      i
    );
  }
}
class M extends H {
  static #e;
  static getInstance() {
    return M.#e || (M.#e = new M()), M.#e;
  }
}
const u = {
  eventErrors: b([]),
  eventPositions: b({}),
  eventSelected: b(),
  events: [],
  footerPositions: b([]),
  timelineDataEvents: {}
}, _ = (f = () => "") => {
  const { actualZoom: e } = v(), t = M.getInstance(), i = () => {
    u.eventErrors.value = [], u.eventSelected.value = null, u.events = [], u.eventPositions.value = {}, u.footerPositions.value = [], u.timelineDataEvents = {};
  }, n = () => u.events.reduce((m, l) => (m[l.id] = l, m), {}), s = () => {
    u.footerPositions.value = [], [...document.querySelector(".timeline__footer")?.children ?? []].forEach((m, l) => {
      try {
        u.footerPositions.value.push({
          date: E.utc(m.dataset.date),
          x: l * e.value.divisionWidth
        });
      } catch {
        u.eventErrors.value.push("Invalid date in footer");
      }
    });
  }, a = (m, l) => {
    if (!m?.length) {
      u.eventErrors.value.push(f("__timeline.errors.noEvent"));
      return;
    }
    m.forEach((L) => {
      try {
        u.timelineDataEvents[L.id] = L;
        const p = {
          millennium: { start: 0, end: 0 },
          halfMillennium: { start: 0, end: 0 },
          bicentenary: { start: 0, end: 0 },
          century: { start: 0, end: 0 },
          biDecade: { start: 0, end: 0 },
          decade: { start: 0, end: 0 },
          lustrum: { start: 0, end: 0 },
          biennial: { start: 0, end: 0 },
          year: { start: 0, end: 0 }
        };
        for (const D in l) {
          const { start: w, end: z } = l[D].events[L.id]?.coordinates ?? {};
          p[D] = { start: w ?? 0, end: z ?? null };
        }
        u.events.push(new $(L, p));
      } catch (p) {
        u.eventErrors.value.push(p.message);
      }
    });
  }, r = (m) => {
    u.eventSelected.value = m, t.notify(m);
  }, c = () => {
    u.eventPositions.value = {};
  }, d = () => {
    u.eventSelected.value = null, t.notify(null);
  };
  return {
    ...u,
    resetEventPositions: c,
    eventObservable: t,
    initEvents: a,
    initFooterPositions: s,
    selectEvent: r,
    selectNextPreviousEvent: (m) => {
      let l;
      if (u.eventSelected.value)
        l = n()[u.eventSelected.value[m]];
      else {
        if (m === "previous") {
          d();
          return;
        }
        l = u.events[0];
      }
      if (!l) {
        d();
        return;
      }
      r(l);
    },
    resetEventSelected: d,
    eventsById: n,
    resetEvents: i
  };
};
class B extends T {
  #e;
  #t = null;
  #n = null;
  #r = null;
  #i = null;
  #o = null;
  #d = null;
  #c = null;
  #l = null;
  #s = null;
  constructor() {
    super();
    const { zooms: e, resetObservable: t } = v();
    this.#e = e, t.subscribe(() => this.#h());
    const { eventObservable: i } = _();
    i.subscribe(() => this.#m());
  }
  render() {
    const { timeline: e, zoom: t } = v(), { addEventListener: i } = S(), n = document.createElement("div");
    n.classList.add("timeline__actions"), this.#s = document.createElement("button"), this.#s.title = this._t("__timeline.actions.zoomIn"), this.#s.setAttribute("data-testId", "timeline-actions__zoom-in"), this.#s.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.5,14L20.5,19L19,20.5L14,15.5V14.71L13.73,14.43C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.43,13.73L14.71,14H15.5M9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14M12,10H10V12H9V10H7V9H9V7H10V9H12V10Z" /></svg>', i("click", () => this.#u(), this.#s), t.value === this.#e[this.#e.length - 1] && this.#s.setAttribute("disabled", "disabled"), this.#l = document.createElement("button"), this.#l.title = this._t("__timeline.actions.zoomOut"), this.#l.setAttribute("data-testId", "timeline-actions__zoom-out"), this.#l.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.5,14H14.71L14.43,13.73C15.41,12.59 16,11.11 16,9.5A6.5,6.5 0 0,0 9.5,3A6.5,6.5 0 0,0 3,9.5A6.5,6.5 0 0,0 9.5,16C11.11,16 12.59,15.41 13.73,14.43L14,14.71V15.5L19,20.5L20.5,19L15.5,14M9.5,14C7,14 5,12 5,9.5C5,7 7,5 9.5,5C12,5 14,7 14,9.5C14,12 12,14 9.5,14M7,9H12V10H7V9Z" /></svg>', i("click", () => this.#v(), this.#l), t.value === this.#e[0] && this.#l.setAttribute("disabled", "disabled");
    const { selectNextPreviousEvent: s, resetEventSelected: a, eventSelected: r, timelineDataEvents: c, eventErrors: d } = _(
      this._t
    );
    if (this.#c = document.createElement("button"), this.#c.title = this._t("__timeline.actions.home"), this.#c.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z" /></svg>', i(
      "click",
      () => {
        a(), this._e("back-to-start");
      },
      this.#c
    ), this.#t = document.createElement("button"), this.#t.title = this._t("__timeline.actions.previousEvent"), this.#t.classList.add("timeline__actions__select-event"), this.#t.classList.add("timeline__actions__select-event__prev"), this.#t.insertAdjacentHTML(
      "afterbegin",
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M24,0h-12l-12,12l12,12h12l-12-12l12-12Z" /></svg>'
    ), this.#n = document.createElement("span"), this.#n.classList.add("timeline__actions__select-event__text"), this.#t.appendChild(this.#n), this.#r = document.createElement("span"), this.#r.classList.add("timeline__actions__select-event__date"), this.#t.appendChild(this.#r), i(
      "click",
      () => {
        s("previous"), this._e("nav-previous", { event: c[r.value.id] }), this._e("event-click", c[r.value.id]);
      },
      this.#t
    ), this.#i = document.createElement("button"), this.#i.title = this._t("__timeline.actions.nextEvent"), this.#i.classList.add("timeline__actions__select-event"), this.#i.classList.add("timeline__actions__select-event__next"), this.#d = document.createElement("span"), this.#d.classList.add("timeline__actions__select-event__date"), this.#i.appendChild(this.#d), this.#o = document.createElement("span"), this.#o.classList.add("timeline__actions__select-event__text"), this.#i.appendChild(this.#o), this.#i.insertAdjacentHTML(
      "beforeend",
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M0,0h12l12,12l-12,12h-12l12-12l-12-12Z" /></svg>'
    ), i(
      "click",
      () => {
        s("next"), this._e("nav-next", { event: c[r.value.id] }), this._e("event-click", c[r.value.id]);
      },
      this.#i
    ), this.#m(), d.value.length > 0) {
      const o = document.createElement("div");
      o.classList.add("timeline__actions__error"), o.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M13 14H11V9H13M13 18H11V16H13M1 21H23L12 2L1 21Z" /></svg>', o.title = d.value.join(`
`), e.value.appendChild(o);
    }
    n.appendChild(this.#s), n.appendChild(this.#l), n.appendChild(this.#c), e.value.appendChild(n), e.value.appendChild(this.#t), e.value.appendChild(this.#i);
  }
  #h() {
    this.#t = null, this.#n = null, this.#r = null, this.#i = null, this.#o = null, this.#d = null, this.#c = null, this.#l = null, this.#s && this.#s.parentElement?.removeChild(this.#s), this.#s = null;
  }
  #m() {
    this.#t.classList.remove("timeline__actions__select-event--disabled"), this.#t.removeAttribute("disabled"), this.#i.classList.remove("timeline__actions__select-event--disabled"), this.#i.removeAttribute("disabled");
    const { eventSelected: e, eventsById: t, events: i } = _(), n = (s, a) => {
      const r = a?.hasEndDate && a?.displayDate("end");
      if (s === "previous") {
        this.#n.innerHTML = a?.text ?? "", this.#r.innerHTML = `<span>${a?.displayDate("start") ?? ""}</span>`, r && (this.#r.innerHTML += `<span>↓</span><span>${a?.displayDate("end")}</span>`);
        return;
      }
      this.#o.innerHTML = a?.text ?? "", this.#d.innerHTML = `<span>${a?.displayDate("start") ?? ""}</span>`, r && (this.#d.innerHTML += `<span>↓</span><span>${a?.displayDate("end")}</span>`);
    };
    if (!e.value) {
      if (this.#t.classList.add("timeline__actions__select-event--disabled"), this.#t.setAttribute("disabled", ""), i.length === 0) {
        this.#i.classList.add("timeline__actions__select-event--disabled"), this.#i.setAttribute("disabled", "");
        return;
      }
      n("next", i[0]);
      return;
    }
    e.value.previous ? n("previous", t()[e.value.previous]) : (this.#t.classList.add("timeline__actions__select-event--disabled"), this.#t.setAttribute("disabled", "")), e.value.next ? n("next", t()[e.value.next]) : (this.#i.classList.add("timeline__actions__select-event--disabled"), this.#i.setAttribute("disabled", ""));
  }
  #u() {
    const { setZoom: e, zoom: t } = v(), i = this.#e.indexOf(t.value);
    if (i === -1 || i === this.#e.length - 1) return;
    this.#l?.hasAttribute("disabled") && (this.#l.removeAttribute("disabled"), this.#l.title = this._t("__timeline.actions.zoomOut")), e(this.#e[i + 1]), i + 1 === this.#e.length - 1 && (this.#s.setAttribute("disabled", "disabled"), this.#s.title = this._t("__timeline.actions.max.zoomIn")), this._e("zoom", t);
    const { eventSelected: n, selectEvent: s } = _();
    n.value && s(n.value);
  }
  #v() {
    const { setZoom: e, zoom: t } = v(), i = this.#e.indexOf(t.value);
    if (i === -1 || i === 0) return;
    this.#s?.hasAttribute("disabled") && (this.#s?.removeAttribute("disabled"), this.#s.title = this._t("__timeline.actions.zoomIn")), e(this.#e[i - 1]), i - 1 === 0 && (this.#l?.setAttribute("disabled", "disabled"), this.#l.title = this._t("__timeline.actions.max.zoomOut")), this._e("zoom", t);
    const { eventSelected: n, selectEvent: s } = _();
    n.value && s(n.value);
  }
}
class F extends T {
  #e = null;
  #t;
  constructor() {
    super(), this.#t = new B();
    const { resetObservable: e } = v();
    e.subscribe(() => this.#n());
  }
  render() {
    return this.#e = document.createElement("div"), this.#e.classList.add("timeline__events"), this.#t.render(), this.#r(), this.#e;
  }
  #n() {
    const e = this.#e?.children;
    e && [...e].forEach((t) => t.remove());
  }
  #r() {
    const { events: e } = _();
    e.forEach((t) => {
      this.#e?.appendChild(t.eventContainer);
    });
  }
}
class G extends T {
  #e = [];
  #t = null;
  constructor() {
    super(), this.#n();
    const { i18nObservable: e, zoomObservable: t, resetObservable: i } = v();
    t.subscribe(() => this.#o()), i.subscribe(() => this.#r()), e.subscribe(() => {
      this.#n(), this.#o();
    });
  }
  render() {
    return this.#t = document.createElement("div"), this.#t.classList.add("timeline__footer"), this.#o(), this.#t;
  }
  #n() {
    this.#e = [
      this._t("__timeline.months.jan"),
      this._t("__timeline.months.feb"),
      this._t("__timeline.months.mar"),
      this._t("__timeline.months.apr"),
      this._t("__timeline.months.may"),
      this._t("__timeline.months.jun"),
      this._t("__timeline.months.jul"),
      this._t("__timeline.months.aug"),
      this._t("__timeline.months.sep"),
      this._t("__timeline.months.oct"),
      this._t("__timeline.months.nov"),
      this._t("__timeline.months.dec")
    ];
  }
  #r() {
    this.#t.innerHTML = "";
  }
  #i() {
    const e = document.createElement("div");
    return e.classList.add("timeline__footer__division"), e;
  }
  #o() {
    const { actualZoom: e } = v();
    this.#r(), this.#t.style.setProperty("--division-width", `${e.value.divisionWidth}px`);
    const t = new E(e.value.timelineLimits.start);
    for (let i = 0; i < e.value.divisionNb + e.value.screenDivisionNb - 1; i++) {
      const n = this.#i();
      e.value.divisionType === "month" ? t.month === 1 ? (n.classList.add("timeline__footer__division--main"), n.innerHTML = `${t.year}`) : n.innerHTML = `${this.#e[t.month - 1]}` : n.innerHTML = `${t.year}`, t.add(e.value.diffDivision, e.value.divisionType), this.#t.appendChild(n);
    }
  }
}
class V extends T {
  #e;
  #t;
  #n;
  #r = !1;
  constructor(e, t, i) {
    if (g.reset(), super(e, i?.language), this.#i(t), !e) throw new Error(this._t("__timeline.errors.HTMLContainerNotDefined"));
    const { setElementContainer: n, initZoom: s, initZoomsData: a, initDarkMode: r, timelineIsOnGoing: c } = v();
    n(e), c.value = t.isOnGoing, r(i?.dark ?? !1), a(t.zooms), s(t.initialZoom);
    const { initEvents: d, eventObservable: o, eventErrors: m } = _(this._t.bind(this));
    d(t.events, t.zooms), o.subscribe(() => this.#d()), this.#r = m.value.length > 0, this.#e = new F(), this.#t = new G(), this.#c(), i?.eventSelected && this.setEventSelected(i.eventSelected);
  }
  get locale() {
    return this._i18n.locale;
  }
  get eventSelected() {
    const { eventSelected: e } = _();
    return e.value;
  }
  get zoom() {
    return v().zoom.value;
  }
  reset() {
    g.reset();
    const { removeEventListeners: e } = S();
    e();
    const { i18nObservable: t, timelineContainer: i, resetTimeline: n, resetObservable: s } = v();
    i.value.style.transform = "translateX(0)", i.value.style.width = "100dvw", n();
    const { resetEvents: a, eventObservable: r } = _();
    a(), r.reset(), [...i.value.children].forEach((c) => c.remove()), t.notify(), s.notify();
  }
  setDarkMode(e) {
    const { setDarkMode: t, timeline: i } = v();
    i.value.classList.toggle("dark", e), t(e);
  }
  setEventSelected(e) {
    const { selectEvent: t, eventsById: i } = _(), n = i()[e];
    n && t(n);
  }
  setEvents(e) {
    const { initEvents: t } = _();
    t(e.events, e.zooms), this.#e.render();
  }
  setLocale(e) {
    this._i18n.locale = e;
    const { i18nObservable: t } = v();
    t.notify();
  }
  #i(e) {
    if (!("events" in e))
      throw new Error(this._t("__timeline.errors.format.eventsNotDefined"));
    if (!Array.isArray(e.events))
      throw new Error(this._t("__timeline.errors.format.eventsWrongFormat"));
    if (!("initialZoom" in e))
      throw new Error(this._t("__timeline.errors.format.initialZoomNotDefined"));
    if (![
      "millennium",
      "halfMillennium",
      "bicentenary",
      "century",
      "biDecade",
      "decade",
      "lustrum",
      "biennial",
      "year"
    ].includes(e.initialZoom))
      throw new Error(this._t("__timeline.errors.format.initialZoomWrongFormat"));
    if (!("isOnGoing" in e))
      throw new Error(this._t("__timeline.errors.format.isOnGoingNotDefined"));
    if (typeof e.isOnGoing != "boolean")
      throw new Error(this._t("__timeline.errors.format.isOnGoingWrongFormat"));
    if (!("zooms" in e))
      throw new Error(this._t("__timeline.errors.format.zoomsNotDefined"));
    if (typeof e.zooms != "object")
      throw new Error(this._t("__timeline.errors.format.zoomsWrongFormat"));
  }
  #o(e) {
    if (!e.buttons) return;
    let t = e.clientX - this.#n;
    const { timelineContainer: i } = v();
    if (t > 0) {
      this.#n = e.clientX - i.value.getBoundingClientRect().left;
      return;
    }
    const { actualZoom: n } = v();
    t - window.innerWidth < -n.value.timelineWidth && (t = -n.value.timelineWidth + window.innerWidth), i.value.style.transform = `translateX(${t}px)`;
  }
  #d() {
    const { eventSelected: e, eventPositions: t } = _(), { timelineContainer: i } = v();
    if (i.value.classList.add("timeline__container--transition"), setTimeout(() => i.value.classList.remove("timeline__container--transition"), 250), !e.value || !t.value[e.value.id]) {
      i.value.style.transform = "translateX(0)";
      return;
    }
    const { width: n, left: s } = t.value[e.value.id];
    if (n > window.innerWidth) {
      i.value.style.transform = `translateX(${-s + 45}px)`;
      return;
    }
    const a = s + n / 2, r = window.innerWidth / 2 - a;
    if (r > 0) {
      i.value.style.transform = "translateX(0)";
      return;
    }
    const { actualZoom: c } = v();
    if (r - window.innerWidth < -c.value.timelineWidth) {
      i.value.style.transform = `translateX(${-c.value.timelineWidth + window.innerWidth}px)`;
      return;
    }
    i.value.style.transform = `translateX(${window.innerWidth / 2 - a}px)`;
  }
  #c() {
    const { actualZoom: e, timeline: t, timelineContainer: i, timelineLoadingContainer: n, zoomObservable: s, dark: a } = v(), { addEventListener: r } = S();
    t.value.classList.add("timeline"), t.value.classList.toggle("dark", a), i.value.classList.add("timeline__container"), i.value.appendChild(this.#e.render());
    const c = this.#t.render();
    i.value.appendChild(c), r(
      "mousedown",
      (l) => {
        this.#n = l.clientX - i.value.getBoundingClientRect().left;
      },
      i.value
    ), r("mousemove", (l) => this.#o(l), i.value), t.value.appendChild(i.value), this._htmlElement.appendChild(t.value), i.value.style.setProperty("--tl-width", `${e.value.timelineWidth}px`), this.#r && i.value.classList.add("timeline__container--error"), n.value.classList.add("timeline__loading"), n.value.innerHTML = this._t("__timeline.loading"), t.value.appendChild(n.value);
    const { eventPositions: d, events: o, initFooterPositions: m } = _();
    m(), d.value = {}, o.forEach((l) => l.updateRenderPosition()), s.subscribe(() => {
      const { actualZoom: l } = v(), { resetEventPositions: L } = _();
      i.value.style.setProperty("--tl-width", `${l.value.timelineWidth}px`), L(), o.forEach((w) => w.updateRenderPosition());
      const p = i.value.style.transform;
      if (p === "") return;
      parseInt(p.split("(")[1].split("px")[0]) + l.value.timelineWidth < window.innerWidth && (i.value.style.transform = `translateX(${window.innerWidth - l.value.timelineWidth}px)`);
    });
  }
}
export {
  V as Timeline
};
//# sourceMappingURL=timeline.js.map
